//区域管理
import http from '../jslibs/axios/http';
import dLAxiosFile from '@/jslibs/axios/download-file';
import dkAxiosFile from '@/jslibs/axios/axios-file';

//获取知识库列表 
export const getDataSetList = data => http.get('/cms/DataSetList', data);

//获取知识库列表不分页
export const getDataSets = data => http.get('/cms/DataSet', data);

//新增知识库 
export const addCmsDataSet = data => http.post('/cms/DataSet', data);
//编辑知识库 
export const updateCmsDataSet = data => http.put('/cms/DataSet/'+data.uuid, data);
//知识库详情 
export const getDataSetDetail = data => http.get('/cms/DataSet/'+data.uuid);

//新增文件
export const addDataSetFile = data => http.post('/cms/DataSetFile', data);

//获取excel导入数据中的数据表列表
export const getDataSetExcelInfo = data => http.get('/cms/DataSetExcelInfo/'+data.uuid);

//获取excel预览数据
export const getDataSetExcel = data => http.get('/cms/DataSetExcel/'+data.$uid,data);

//上传excel
export const addDataSetExcel = (data) => dkAxiosFile({
	url: '/cms/DataSetExcel',
	headers: {
		'content-type': 'multipart/form-data'
	},
	method: 'POST',
	data
});

//删除知识库 
export const deleteDataSet = data => http.delete('/cms/DataSet/' + data.id, data);

//获取知识库详情 
export const regionread = data => http.post('/admin/region/read', data);

//导出知识库列表 
export const regionexport = data => dLAxiosFile({
	url: '/admin/region/export',
	method: 'GET',
	params: data
});


//获取ai应用列表 
export const getAiapplicationList = data => http.get('/cms/Aiapplication', data);

//新增ai应用 
export const addAiapplication = data => http.post('/cms/Aiapplication', data);

//编辑ai应用 
export const editAiapplication = data => http.put('/cms/Aiapplication/' + data.uuid, data);

//上下架ai应用 
export const AiApplicationOption = data => http.post('/cms/AiApplicationOption', data);

//删除ai应用 
export const deleteAiapplication = data => http.delete('/cms/Aiapplication/' + data.id, data);

//获取ai应用详情 
export const getAiapplication = data => http.get('/cms/Aiapplication/' + data.uuid);

//获取ai应用分类列表
export const getAiApplicationClass = data => http.get('/cms/AiApplicationClass?type=1');

//获取文件列表
export const getDataSetFile = data => http.get('/cms/DataSetFile', data);

//获取文件列表
export const addTableDataSetFile = data => http.post('/cms/DataSetFile', data);

//删除文件
export const deleteDataSetFile = data => http.delete('/cms/DataSetFile/' + data.uuid);


//获取语料
export const getDataSetYuliao = data => http.get('/cms/DataSetYuliao', data);

//获取语料列表
export const editTableDataSetYuliao = data => http.put('/cms/DataSetYuliao/'+data.id, data);

//删除语料
export const deleteDataSetYuliao = data => http.delete('/cms/DataSetYuliao/' + data.id);